import React from 'react'
import PropTypes from 'prop-types'

import { Image, Motion, Text, Wrapper } from 'Components/UI'

import size from 'lodash/size'

import { Container, Content, ImageHolder } from './styles'

function WorkWith({ data }) {
  if (!size(data)) return null
  return (
    <Container>
      <Wrapper flexDirection="column">
        <Text justify light markdown>
          Worked with:
        </Text>

        <Motion>
          <Content>
            {data.map(entity => (
              <Motion key={entity?.id}>
                <ImageHolder>
                  <Image alt="" image={entity} />
                </ImageHolder>
              </Motion>
            ))}
          </Content>
        </Motion>
      </Wrapper>
    </Container>
  )
}

WorkWith.defaultProps = {
  data: [],
}

WorkWith.propTypes = {
  data: PropTypes.array,
}

export default WorkWith
